import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {OverlayWindowData} from "../../overlay/overlay-window-data";
import {take} from "rxjs";
import {DisplayService} from "../../services/display.service";
import {ProjectAreaService} from "../../services/project-area.service";
import {ProjectArea} from "../../enums/project-area";

@Component({
  selector: 'brt-overlay-window',
  templateUrl: './overlay-window.component.html',
  styleUrls: ['./overlay-window.component.scss']
})
export class OverlayWindowComponent implements OnInit, AfterViewInit, OnDestroy, Overlayable {

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @ViewChild("contentEl", {read: ViewContainerRef}) contentEl!: ViewContainerRef;
  @ViewChild("footerEl", {read: ViewContainerRef}) footerEl!: ViewContainerRef;
  @ViewChild("headerEl", {read: ViewContainerRef}) headerEl!: ViewContainerRef;
  @ViewChild("dialogElement") dialogElement!: ElementRef<HTMLDialogElement>;

  @ViewChild('windowContentEl') windowContentEl!: ElementRef;

  theme: string = "";

  @Input("data") set setComponentData(val: OverlayWindowData) {
    this.componentData = val;
  }
  // title = "";
  componentData!: OverlayWindowData;
  animInState = false;

  @HostListener("click", ["$event"])
  onClick($event: PointerEvent) {
    // const target = $event.target as HTMLElement;
    const target = this.mouseDownTarget;
    // console.log($event);
    if(target) {
      if(!target.closest(".overlay-window__window-inner-content")) {
        // if click inside overlay leads to remove of the target element (e.g. *ngIf)
        // in such case it doesn't exist on the page anymore and overlay will be closed
        // but overlay should always remain opened if such click happens
        if(!target.closest("brt-overlay-window")) return;
        // console.warn("Closed on click outside");

        if(this.isExternalCloseBlocked()) return;

        if(this.componentData.onCancel) {
          this.componentData.onCancel();
        }
        this.onClosed.emit(true);
      }
    }

  }

  // True when an external close (backdrop, header X, ESC) is currently disallowed.
  isExternalCloseBlocked(): boolean {
    const block = this.componentData.blockExternalClose;
    return typeof block === 'function' ? block() : !!block;
  }

  onDialogCancel($event: Event) {
    // Native <dialog> ESC; prevent it from closing while external close is blocked.
    if(this.isExternalCloseBlocked()) {
      $event.preventDefault();
    }
  }

  // ESC on document level: stop it before the overlay service's window-level handler
  // can remove this overlay while external close is blocked.
  @HostListener("document:keydown.escape", ["$event"])
  onEscapeKey($event: KeyboardEvent) {
    if(this.isExternalCloseBlocked()) {
      $event.preventDefault();
      $event.stopImmediatePropagation();
    }
  }

  mouseDownTarget?: HTMLElement;
  @HostListener("mousedown", ["$event"])
  onMouseDownClick($event: PointerEvent) {
    this.mouseDownTarget = $event.target as HTMLElement;
  }

  constructor(private displayService: DisplayService, private projectAreaService: ProjectAreaService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.dialogElement.nativeElement.showModal();

    window.requestAnimationFrame(() => {
      const mainComponent = this.contentEl.createComponent(this.componentData.componentMain.component);
      for(const key in this.componentData.componentMain.data) {
        mainComponent.setInput(key, this.componentData.componentMain.data[key]);
      }
      mainComponent.changeDetectorRef.detectChanges();
      mainComponent.instance.onClosed.pipe(take(1)).subscribe(() => {
        this.onClosed.emit(true);

        this.goToPreviousActiveElement();
      })

      if(this.componentData.componentFooter) {
        const footerComponent = this.footerEl.createComponent(this.componentData.componentFooter.component);
        for(const key in this.componentData.componentFooter.data) {
          footerComponent.setInput(key, this.componentData.componentFooter.data[key]);
        }
        footerComponent.changeDetectorRef.detectChanges();
        footerComponent.instance.onClosed.pipe(take(1)).subscribe(() => {
          this.onClosed.emit(true);
          this.goToPreviousActiveElement();
        })
      }

      if(this.componentData.componentHeader) {
        const headerComponent = this.headerEl.createComponent(this.componentData.componentHeader.component);
        for(const key in this.componentData.componentHeader.data) {
          headerComponent.setInput(key, this.componentData.componentHeader.data[key]);
        }
        headerComponent.changeDetectorRef.detectChanges();
        headerComponent.instance.onClosed.pipe(take(1)).subscribe(() => {

          if(this.componentData.onCancel) {
            this.componentData.onCancel();
          }

          this.onClosed.emit(true);
        })
      }

      window.requestAnimationFrame(() => {
        this.animInState = true;
      })

      this.displayService.addElementFillVVHeight(this.windowContentEl.nativeElement);

      this.theme = this.componentData.theme ?? "";

      // console.log(this.dialogElement);
    })



  }

  ngOnDestroy() {
    // console.log(this.windowContentEl.nativeElement);
    this.displayService.removeElementFillVVHeight(this.windowContentEl.nativeElement);
    this.dialogElement.nativeElement.close();

  }

  onHeaderClosedEmitted($event: boolean) {
    if(this.isExternalCloseBlocked()) return;

    if(this.componentData.onCancel) {
      this.componentData.onCancel();
    }

    this.onClosed.emit(true);

    this.goToPreviousActiveElement();

  }

  goToPreviousActiveElement() {

    (window.document.activeElement as HTMLElement).blur();
    // console.log(this.componentData.previousActiveElement);
    if(this.componentData.previousActiveElement) {
      this.componentData.previousActiveElement.focus();
    }

  }
}
